import { Injectable, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BecareService } from './becare.service';
import { CNPatient } from '../models/cnpatient';
import { CNItem } from '../models/cnitem';
import { UserService } from './user.service';

declare var Ext: any;
declare var gUserId: number;
declare var gUser: any;
declare var gTranslator: any;

@Injectable({
  providedIn: 'root'
})
export class UserConfigService {

  private static instance: UserConfigService = null;

  // User config
  config: any = {};
  loaded = false;
  sessionid = '';
  remoteaddr = '';
  userGroups = '';
  switchGroups = [];
  userid = -1;
  user: any;
  adminMenus: any;
  userMenus: any;
  contentMenus: any;
  companion: any;
  labo: any;
  profile: any;
  userSearch: any;
  userSearchOptions: any;

  // User session
  sessionPatient: CNPatient;
  sessionOpenItems: CNItem[] = [];

  @Output() configLoaded: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient, private becare: BecareService,
              private userSrv: UserService) {
    console.log('Hello UserConfigProvider Provider');
    UserConfigService.instance = this;
    this.becare.authStatus().subscribe(status => {
      if (status === true) {
        console.log('UserConfigService loading user config');
        this.userid = becare.userid;
        gUserId = becare.userid;
        // User
        gUser = new Ext.SNUser(gUserId);
        // Wait user to be loaded
        gUser.on('itemLoaded', (item) => {
          gTranslator = new Ext.SNTranslator();
          gTranslator.loadTranslators(['General', 'DomainAdmin', 'ActionPanel'], 'code', 'fr');
        });
        this.loadConfig();
        this.loadSession();
      }
    });
  }

  public static getInstance(): UserConfigService {
    return UserConfigService.instance;
  }

  loadConfig() {
    this.becare.call('/user/' + this.userid  + '/ui/config')
    .subscribe(result => {
      if (result.success === false) {
        // User ot logged in
      }
      this.config = result.config;
      this.sessionid = this.config.session.id;
      this.remoteaddr = this.config.remote_addr;
      this.user = this.config.user;
      this.companion = this.config.companion;
      this.labo = this.config.labo;
      this.profile = this.config.profile;
      this.userGroups = '';
      for (const group of this.config.groups) {
        if (this.userGroups.length !== 0) {
          this.userGroups += ' - ';
        }
        if (group.maingroup === true) {
            this.userGroups += '<span class="user-domainname">';
        }
        this.userGroups += group.name;
        if (group.maingroup === true) {
          this.userGroups += '</span>';
        }
      }
      if (typeof(this.config.maingroupswitch) !== 'undefined' &&
          this.config.maingroupswitch.display === true) {
          this.switchGroups = this.config.maingroupswitch.groups;
      }
      // Sort admin menus by index
      const admMenus = [];
      for (const menu of this.config.menus.admin) {
        if (typeof menu === 'object') {
          admMenus.push(menu);
        }
      }
      this.adminMenus = admMenus.sort((obj1, obj2) => {
        return obj1.index - obj2.index;
      });
      // Sort user menus by index
      const usrMenus = [];
      for (const menu of this.config.menus.user) {
        if (typeof menu === 'object') {
          usrMenus.push(menu);
        }
      }
      this.userMenus = usrMenus.sort((obj1, obj2) => {
        return obj1.index - obj2.index;
      });
      // Sort content menus by index
      const cntMenus = [];
      for (const menu of this.config.menus.content) {
        if (typeof menu === 'object') {
          cntMenus.push(menu);
        }
      }
      this.contentMenus = cntMenus.sort((obj1, obj2) => {
        return obj1.index - obj2.index;
      });
      if ((result as any).patientsearch !== undefined) {
        this.userSearch = (result as any).patientsearch.results;
        if ((result as any).patientsearch.options !== undefined) {
          this.userSearchOptions = (result as any).patientsearch.options;
        }
      }
      // load user here, to avoid missing event if service is not yet instanciated.
      this.userSrv.userid = this.user.id;
      // send event
      this.configLoaded.emit(this.config);
      this.loaded = true;
    });
  }

  public loadSession(): void {

  }

  public profileValue(profileName: string, key: string): string | boolean {
    if (!this.profile) {
      return undefined;
    }
    if (!this.profile[profileName]) {
      return undefined;
    }
    const profile: Array<any> = this.profile[profileName];
    let value: string | boolean;
    profile.forEach(aProfile => {
      if (aProfile[key]) {
        const profileValue: string = aProfile[key].toLowerCase();
        value = (profileValue === 'yes' || profileValue === 'no') ? (profileValue === 'yes') ? true : false : aProfile[key];
      }
    });
    return value;
  }

  public currentGroup(): [string, string] {
    let group: [string, string] = ['', ''];
    for (const usergroup of this.config.groups) {
      if (usergroup.maingroup === true) {
        group = [usergroup.id, usergroup.name];
      }
    }
    return group;
  }

  public domainIdIsMainGroup(domainid: number): boolean {
    // find switch group with same id
    let switchgroup;
    if (typeof(this.config.maingroupswitch) !== 'undefined' &&
        typeof(this.config.maingroupswitch.groups) !== 'undefined' &&
        Array.isArray(this.config.maingroupswitch.groups)) {
          this.config.maingroupswitch.groups.forEach(group => {
            if (parseInt(group.id, 10) === domainid) {
              switchgroup = group;
            }
          });
    }
    if (!switchgroup) {
      return false;
    }
    // get group with same id and is maingroup
    let samegroup;
    for (const group of this.config.groups) {
      if (group.name === switchgroup.name && group.maingroup === true) {
        samegroup = group;
      }
    }
    if (!samegroup) {
      return false;
    }
    return true;
  }
}
